<div class="container">
  <div class="top">
    <h3>Session Workflow</h3>
    <div class="controls">
      <button class="btn btn-primary" (click)="openAddSession()">
        Add Session
      </button>
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>

  <div class="pane">
    <div
      class="vertex"
      *ngFor="let vertex of workflow.vertices"
      ngDraggable
      [position]="vertex"
      (movingOffset)="vertexMoved(vertex, $event)"
      (click)="endEdge(vertex)"
      [ngClass]="{ deactive: vertex.ref.config.deactivated }">
      <div ngbDropdown class="menu">
        <i ngbDropdownToggle class="glyphicon icon-more"></i>
        <div ngbDropdownMenu>
          <div ngbDropdownItem (click)="createEdge(vertex)">Link</div>
          <div ngbDropdownItem (click)="removeSession(vertex.ref)">Remove</div>
        </div>
      </div>

      <div class="title">
        <span>{{ vertex.ref.config.title }}</span>
        <div class="deactive-indicator" *ngIf="vertex.ref.config.deactivated">
          Not Active
        </div>
      </div>
      <div class="image">
        <img
          alt
          [src]="
            vertex.ref.config.thumbnail_id ||
              'image/default_session_thumbnail.png' | assets
          " />
      </div>
    </div>

    <div
      class="edge free-edge"
      *ngIf="freeEdge"
      [ngStyle]="{ transform: edgeTransform(freeEdge) }">
      <img
        alt
        [ngStyle]="{ transform: edgeChevronTransform(freeEdge) }"
        src="assets/images/workflow-arrow.svg" />
    </div>
    <div
      class="edge"
      *ngFor="let edge of workflow.edges"
      [ngStyle]="{ transform: edgeTransform(edge) }"
      (click)="removeEdge(edge)">
      <img
        alt
        [ngStyle]="{ transform: edgeChevronTransform(edge) }"
        src="assets/images/workflow-arrow.svg" />
    </div>
  </div>

  <div
    class="sessions-side-panel"
    [ngClass]="{
      open: addSessionOpened,
    }">
    <button
      type="button"
      (click)="closeAddSession()"
      class="btn-close"
      title="Close"></button>
    <div
      class="to-be-added-session"
      *ngFor="let session of addableSessions"
      [ngClass]="{ deactive: session.config.deactivated }"
      (mousedown)="addSession(session)">
      <div class="deactive-indicator" *ngIf="session.config.deactivated">
        Not Active
      </div>
      <div class="title">
        {{ session.config.title }}
      </div>
      <div class="image">
        <img
          alt
          [src]="
            session.config.thumbnail_id || 'image/default_session_thumbnail.png'
              | assets
          " />
      </div>
    </div>
  </div>
</div>
